import { render, staticRenderFns } from "./PreOrdenes.vue?vue&type=template&id=38bb18b2&"
import script from "./PreOrdenes.vue?vue&type=script&lang=js&"
export * from "./PreOrdenes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports